import { Injectable } from '@angular/core';
import { DataType, ExtensionCommunicationService } from '@shared/extension';
import { StoreName } from '../enums';
import { AssetsState } from '../interfaces';
import { AbstractStore } from './abstract';

@Injectable()
export class AssetsStore extends AbstractStore<AssetsState> {
  // Main selectors
  readonly assetsPath$ = this.select('assetsPath');

  constructor(protected extensionCommunicationService: ExtensionCommunicationService) {
    super(extensionCommunicationService, StoreName.AssetsStore, {
      assetsPath: ['assets', DataType.String],
    });
  }

  setAssetsPath(data: string): void {
    this.updateStateProp('assetsPath', data);
  }
}
